var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"no-data-background",style:(_vm.getStyle),attrs:{"aria-hidden":"true","data-testid":"no-data-bg-image"}},[_c('BaseText',{staticClass:"no-data-text",attrs:{"color":_vm.NebraskaColors.textSecondary,"size":"s","data-testid":"no-data-text"}},[_vm._v(" "+_vm._s(_vm.noContentText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }